module.exports = __webpack_public_path__ + "static/media/HindVadodara-Bold.80ff3138.eot";